// extracted by mini-css-extract-plugin
module.exports = {"cardLayout":"styles_cardLayout__1ypTX","cardLayoutMobile":"styles_cardLayoutMobile__1xdmI","card":"styles_card__1aUAL","footer":"styles_footer__3YjfD"};